import {
  FETCH_DELIVERY_PERSON,
  RESET_DELIVERY_PERSON,
} from "../../constants/action.constants";

const initialState = {
  data: {},
};

const deliveryPersonViewReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DELIVERY_PERSON:
      return { data: action.payload };
    case RESET_DELIVERY_PERSON:
      return initialState;
    default:
      return state;
  }
};

export default deliveryPersonViewReducer;
